<div class="container">
    <img
        alt="Guitar pick"
        class="guitarPick"
        src="../../assets/guitarPick.svg"
    />

    <div class="wrapper">
        <!-- HEADER -->
        <div class="headerContainer">
            <div class="logoWrapper">
                <img
                    class="controlant-logo"
                    src="../../assets/controlant-logo-color.svg"
                />
            </div>
        </div>

        <div class="contentContainer">
            <div class="contentHeader">
                <h4 i18n="Request password reset success headline@@requestPwResetSuccessHeadline">Instructions sent!</h4>
            </div>
            <div  i18n="Request password reset success text@@requestPwResetSuccessText">
                <p>
                    An e-mail containing a link to set your new password has been sent to your registered e-mail address.
                </p>
                <p>
                    If you do not receive an e-mail within the next 5 minutes, make sure you used a valid username and be sure to also check your spam folder.
                </p>
                <p>
                    For further assistance, contact your Controlant supplier or <a href="mailto:support@controlant.com">Controlant Support</a>.
                </p>
            </div>
        </div>
    </div>

</div>
